export const GET_TRANSACTION_DATA = 'GET_TRANSACTION_DATA'
export const GET_TRANSACTION_DATA_FAILED = 'GET_TRANSACTION_DATA_FAILED'
export const GET_TRANSACTION_DATA_SUCCEEDED = 'GET_TRANSACTION_DATA_SUCCEEDED'

export const GET_ARCHIVE_TRANSACTION_DATA = 'GET_ARCHIVE_TRANSACTION_DATA'
export const GET_ARCHIVE_TRANSACTION_DATA_FAILED = 'GET_ARCHIVE_TRANSACTION_DATA_FAILED'
export const GET_ARCHIVE_TRANSACTION_DATA_SUCCEEDED = 'GET_ARCHIVE_TRANSACTION_DATA_SUCCEEDED'

export const UPDATE_ARCHIVE_TRANSACTION_DATA = 'UPDATE_ARCHIVE_TRANSACTION_DATA'
export const UPDATE_ARCHIVE_TRANSACTION_DATA_FAILED = 'UPDATE_ARCHIVE_TRANSACTION_DATA_FAILED'
export const UPDATE_ARCHIVE_TRANSACTION_DATA_SUCCEEDED = 'UPDATE_ARCHIVE_TRANSACTION_DATA_SUCCEEDED'
